<template>
  <article class="message is-primary">
    <div class="message-header">
      <p>{{ $t('title.payment3d') }}</p>
    </div>
    <div class="message-body">
      <div class="columns">
        <div class="column b-portlet" style="background-color: rgb(251, 251, 251);">
          <div class="b-portlet-body " style="height:500px;">
            <div v-show="isWaiting">{{ $t('description.pleaseWait') }}</div>
            <iframe
              id="iframe3d"
              :srcdoc="htmlContent"
              style=" overflow-y: scroll; height: 74%; width:92%; position: absolute; padding:20px"
            ></iframe>
          </div>
        </div>
      </div>
    </div>
  </article>
</template>
<script>
export default {
  props: {
    htmlContent: {
      type: String
    }
  },
  data () {
    return {
      iframeRefreshCount: 0,
      isWaiting: false
    }
  },
  mounted () {
    const iframeElement = document.querySelector('#iframe3d')
    iframeElement.onload = () => {
      this.iframeRefreshCount = this.iframeRefreshCount + 1
      if (this.iframeRefreshCount > 2) {
        this.isWaiting = false
      } else if (this.iframeRefreshCount > 1) {
        this.isWaiting = true
      }
    }
  }
}
</script>
